import './../../scss/baseLayout.scss';
// eslint-disable-next-line no-unused-vars
import * as bootstrap from 'bootstrap';

/**
 * Um segundo em milissegundos
 */
const oneSecondInMilli = 1000;

/**
 * Tempo em milissegundos para fechar alertas automaticamente
 */
const timeToCloseModal = oneSecondInMilli * 10;

/**
 * Tempo em milissegundos para redirecionar para outra página
 */
const timeToRedirect = oneSecondInMilli * 5;

/**
 * Timeout para os alerts
 */
let alertTimeout = null;

/**
 * Exibe alertas com mensagens
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 *
 * @param {string} message - mensagem a ser exibida no alerta
 * @param {string} type - tipo do alerta a ser exibido (error, warning, info ou success)
 */
export function showAlert(message, type)
{
    if (['error', 'warning', 'success', 'info'].includes(type))
    {
        const showedAlert = document.querySelector('.alert.alert-dismissible.alert-center.fade.show');
        if (showedAlert !== null) // Se tem algum alerta aberto, fecha
        {
            showedAlert.classList.remove('show');
        }

        removeAlertTimeout();

        if (type === 'error')
        {
            const errorAlert = document.querySelector('#errorAlert');
            const errorMessage = errorAlert.querySelector('span');

            errorMessage.innerHTML = message;
            errorAlert.classList.add('show');

            alertTimeout = setTimeout(() =>
            {
                errorAlert.classList.remove('show');
                alertTimeout = null;
            }, timeToCloseModal);
        }
        else if (type === 'warning')
        {
            const warningAlert = document.querySelector('#warningAlert');
            const warningMessage = warningAlert.querySelector('span');

            warningMessage.innerHTML = message;
            warningAlert.classList.add('show');

            alertTimeout = setTimeout(() =>
            {
                warningAlert.classList.remove('show');
                alertTimeout = null;
            }, timeToCloseModal);
        }
        else if (type === 'success')
        {
            const successAlert = document.querySelector('#successAlert');
            const successMessage = successAlert.querySelector('span');

            successMessage.innerHTML = message;
            successAlert.classList.add('show');

            alertTimeout = setTimeout(() =>
            {
                successAlert.classList.remove('show');
                alertTimeout = null;
            }, timeToCloseModal);
        }
        else
        {
            const infoAlert = document.querySelector('#infoAlert');
            const infoMessage = infoAlert.querySelector('span');

            infoMessage.innerHTML = message;
            infoAlert.classList.add('show');

            alertTimeout = setTimeout(() =>
            {
                infoAlert.classList.remove('show');
                alertTimeout = null;
            }, timeToCloseModal);
        }
    }
}

/**
 * Remove timeout que foi adicionado para fechar alertas automaticamente
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 */
function removeAlertTimeout()
{
    if (alertTimeout !== null)
    {
        clearTimeout(alertTimeout);
        alertTimeout = null;
    }
}

/**
 * Inicializa os alertas do sistema
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 */
function initializeAlerts()
{
    const alerts = document.querySelectorAll('.alert.alert-dismissible.alert-center.fade');
    alerts.forEach((alert) =>
    {
        const btnClose = alert.querySelector('.btn-close');
        btnClose.addEventListener('click', () =>
        {
            alert.classList.remove('show');
            removeAlertTimeout();
        });
    });

    const showedAlerts = document.querySelectorAll('.alert.alert-dismissible.alert-center.fade.show');
    showedAlerts.forEach((alert) =>
    {
        alertTimeout = setTimeout(() =>
        {
            alert.classList.remove('show');
            alertTimeout = null;
        }, timeToCloseModal);
    });
}

/**
 * Mostra ou esconde loader
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 *
 * @param {boolean} show - indica se o loader deve ser mostrado ou não
 */
export function loader(show)
{
    const loaderDiv = document.querySelector('#loader');

    if (show)
    {
        loaderDiv.classList.add('show');
    }
    else
    {
        loaderDiv.classList.remove('show');
    }
}

/**
 * Checa se a política de cookies já foi aceita,
 * se não tiver sido, mostra alerta com a autorização
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 */
function cookiesDialog()
{
    const acceptCookies = getCookie('cookies');

    if (acceptCookies !== 'true')
    {
        const cookies = document.querySelector('#cookies');
        const btnCookiesOk = document.querySelector('#btnCookiesOk');

        cookies.classList.add('show');

        btnCookiesOk.addEventListener('click', () =>
        {
            setCookie('cookies', 'true');
            cookies.classList.remove('show');
        });
    }
}

/**
 * Cria um cookie
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 *
 * @param {string} name - nome do cookie a ser criado
 * @param {string} value - valor do cookie a ser criado
 * @param {string} [path="/"] - caminho do domínio onde o cookie vai ser criado
 * @param {string} [SameSite="Lax"] - definição SameSite do cookie a ser criado
 */
export function setCookie(name, value, path = '/', SameSite = 'Lax')
{
    const d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=${path};SameSite=${SameSite};`;
}

/**
 * Retorna o valor de um cookie, procurando pelo
 * nome do cookie
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 *
 * @param {string} name - nome do cookie a ter o valor retornado
 * @returns {string} valor do cookie buscado ou uma string vazia
 */
export function getCookie(name)
{
    if (name.charAt(name.length - 1) !== '=')
    {
        name = name + '=';
    }

    const decodedCookie = decodeURIComponent(document.cookie);
    const splittedDecodedCookie = decodedCookie.split(';');
    let cookieValue = '';

    for (let i = 0; i < splittedDecodedCookie.length; i++)
    {
        let c = splittedDecodedCookie[i];
        while (c.charAt(0) === ' ')
        {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0)
        {
            cookieValue = c.substring(name.length, c.length);
        }
    }

    return cookieValue;
}

/**
 * Faz requisições Ajax.
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 *
 * @param {string} method - método da requisição (GET, POST)
 * @param {string} action - ação da requisição (URL)
 * @param {FormData} body - corpo da requisição (Dados a serem enviados)
 * @param {boolean} changeUrl - indica se a URL da página deve ser modificada
 *
 * @returns {Promise<unknown>} Resolução da Promise com o JSON com a resposta da requisição
 */
export function ajax(method, action, body, changeUrl = true)
{
    return new Promise((resolve, reject) =>
    {
        const xhr = new XMLHttpRequest();

        if (method.toUpperCase() === 'GET')
        {
            const urlSearchParams = new URLSearchParams();

            body.forEach((value, key) =>
            {
                urlSearchParams.append(key, value);
            });

            action += '?' + urlSearchParams.toString();

            if (changeUrl)
            {
                history.pushState({}, document.title, action);
            }
        }

        xhr.open(method, action, true);

        if (method.toUpperCase() === 'GET')
        {
            xhr.setRequestHeader('Content-Type', 'application/json');
        }
        else
        {
            xhr.setRequestHeader('X-CSRF-TOKEN', window._systemCsrfTokenHash);
        }
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        xhr.onload = () =>
        {
            loader(false);

            let responseJSON = { error: 'Erro não identificado ao tentar executar requisição. Por favor, tente novamente mais tarde.' };
            let alertType = 'error';
            try
            {
                responseJSON = JSON.parse(xhr.response);

                if (responseJSON.csrf !== undefined)
                {
                    window._systemCsrfTokenHash = responseJSON.csrf;
                }

                if (xhr.status >= 200 && xhr.status < 300) // A resposta do servidor é sucesso (200 até 299)
                {
                    resolve(responseJSON);
                }
                else // Redirecionou (300 até 399), erro do usuário (400 até 499), erro do servidor (500 até 599)
                {
                    console.error(responseJSON);

                    if (responseJSON.message !== undefined)
                    {
                        responseJSON.error = responseJSON.message;
                    }

                    showAlert(responseJSON.error, alertType);
                    reject(responseJSON);
                }
            }
            catch // Erro ao tentar dar parse na string de resposta para JSON
            {
                if (xhr.status === 200 && xhr.responseURL === (window.location.origin + '/login')) // Sucesso na resposta mas redirecionou para o login = significa que a sessão expirou!
                {
                    let time = timeToRedirect / oneSecondInMilli;
                    responseJSON.error = `Sua sessão expirou. Redirecionando para página de login em <span id="secondsRedirectLogin">${time}</span> segundo(s).`;
                    alertType = 'warning';

                    setInterval(() => // Começar um contador de segundos
                    {
                        document.querySelector('#secondsRedirectLogin').innerHTML = time--;
                    }, oneSecondInMilli);

                    setTimeout(() => // Tempo para redirecionar para o login
                    {
                        window.location.href = xhr.responseURL;
                    }, timeToRedirect);
                }

                // Não entrou em nenhum if? Erro genérico.
                console.error(xhr.response);
                showAlert(responseJSON.error, alertType);
                reject(responseJSON);
            }
        };

        xhr.onerror = () => // Erro ao tentar realizar a requisição
        {
            loader(false);
            let errorJSON = { error: 'Erro não identificado ao tentar executar requisição. Por favor, contate o administrador do sistema.' };
            showAlert(errorJSON.error, 'error');
            reject(errorJSON);
        };

        xhr.send(body);

        loader(true);
    });
}

/**
 * Retorna uma string aleatória, útil para gerar ids aleatórios
 *
 * @author Vinícius Meng <viniciusmeng2@gmail.com>
 * @version 1.0.0
 *
 * @param {string} prefix - prefixo a ser colocado antes da string aleatória
 *
 * @returns {string} String aleatória
 */
export function randomString(prefix)
{
    return Math.random().toString(36).replace('0.', prefix || '');
}

initializeAlerts();
cookiesDialog();
